module.exports = __webpack_public_path__ + "Roboto-Regular.878ad7158f6fa9136d79.woff";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Regular.woff
// module id = ../../../../../src/assets/fonts/Roboto-Regular.woff
// module chunks = main